/**
 * DR Vitamin — sticky Add to Cart behaviour (2026-09-16 optimization program, phase E).
 *
 * The bar itself is the theme's own <sticky-addtocart> (sections/sticky_add_to_cart.liquid, elements.js): it is rendered
 * only for an AVAILABLE product, shows the Liquid price of the selected variant, and its button clicks the page's real
 * Add to Cart — so cart logic, soft inventory and the unavailable state are exactly the product form's. This file only
 * decides WHEN the bar may be on screen:
 *   - held while the main Add to Cart is visible (no two buy buttons at once)
 *   - held while the footer is visible (the bar never covers footer links)
 *   - held while the on-screen keyboard is likely open (a text field has focus)
 * and keeps the bar's hidden quantity equal to the product form's before it buys.
 * A body class mirrors the hold so the contact launcher — which already steps over this bar — re-measures. The launcher
 * itself is not touched.
 */
(function () {
  'use strict';
  var bar = document.querySelector('sticky-addtocart');
  if (!bar) return;
  var main = document.querySelector('#product-single .add-to-cart');
  var footer = document.querySelector('footer') || document.querySelector('[id*="footer"]');
  var state = { main: false, footer: false, typing: false };

  function apply() {
    var hold = state.main || state.footer || state.typing;
    bar.classList.toggle('drv-satc-hold', hold);
    document.body.classList.toggle('drv-satc-hold', hold);
  }

  if ('IntersectionObserver' in window) {
    if (main) {
      new IntersectionObserver(function (entries) {
        var e = entries[entries.length - 1];
        state.main = e.isIntersecting;
        apply();
      }).observe(main);
    }
    if (footer) {
      new IntersectionObserver(function (entries) {
        var e = entries[entries.length - 1];
        state.footer = e.isIntersecting;
        apply();
      }).observe(footer);
    }
  }

  function isTextField(el) {
    if (!el || !el.tagName) return false;
    var t = el.tagName.toLowerCase();
    if (t === 'textarea' || t === 'select') return true;
    if (t !== 'input') return el.isContentEditable === true;
    return !/^(button|submit|checkbox|radio|hidden|reset|image|range|color)$/i.test(el.type || 'text');
  }
  document.addEventListener('focusin', function (e) { if (isTextField(e.target)) { state.typing = true; apply(); } });
  document.addEventListener('focusout', function () { setTimeout(function () { state.typing = isTextField(document.activeElement); apply(); }, 50); });

  /* the bar buys whatever quantity the product form holds */
  document.addEventListener('click', function (e) {
    if (!e.target.closest || !e.target.closest('sticky-addtocart .sticky_atc_js')) return;
    var qMain = document.querySelector('#product-single [name="quantity"]');
    var qBar = bar.querySelector('[name="quantity"]');
    if (qMain && qBar && qMain.value) qBar.value = qMain.value;
  }, true);

  apply();
})();
